import { apiEnv } from '@/config';
import { delayMock } from '@/api/base/delay';

export function getInsuranceCompanyOptions() {
  return [
    { value: "泰康", label: "泰康" },
    { value: "人保", label: "人保" },
    { value: "平安", label: "平安" },
    { value: "利宝", label: "利宝" },
  ];
}

// 业务链路选项
export function getLinkOptions() {
  return [
    { value: 0, label: "人保魔方" },
    { value: 1, label: "百万钩子-重疾均分" },
    { value: 2, label: "魔方升级转重疾均分" },
    { value: 3, label: "特疾钩子-百万均分" },
    { value: 4, label: "双魔方" },
    { value: 5, label: "人保-利宝" },
  ];
}

// 渠道选项
export function getMarketChannelOptions() {
  return [
    { value: 1, label: "零犀BPO" },
    { value: 2, label: "黑牛自建" },
    { value: 3, label: "投放" },
  ];
}


// 年龄段选项
export function getAgeRangeOptions() {
  return [
    { value: '小于等于20', label: "小于等于20" },
    { value: '21-25', label: "21-25" },
    { value: '26-30', label: "26-30" },
    { value: '31-35', label: "31-35" },
    { value: '36-40', label: "36-40" },
    { value: '41-45', label: "41-45" },
    { value: '46-50', label: "46-50" },
    { value: '51-55', label: "51-55" },
    { value: '56-60', label: "56-60" },
    { value: '大于60', label: "大于60" },
  ];
}

// 作业时间选项
export function getWorkTimeOptions() {
  return [
    { value: '', label: "全天：0点到24点", simpleLabel: '全天'},
    { value: 1, label: "工作时间：9点到18点半", simpleLabel: '工作时间'},
    { value: 2, label: "非工作时间：18点半到次日9点", simpleLabel: '非工作时间'},
  ];
}
// 链路选项
export function getLinkOptions2() {
  return [
    { value: 1, label: "泰康魔方转利宝重疾" },
    { value: 2, label: "泰康新农合魔方转利宝重疾" },
    { value: 3, label: "泰康新农合魔方拖单" },
    { value: 4, label: "人保魔方转利宝重疾" },
    { value: 5, label: "其他：其余的全部" },
  ];
}
// 投诉来源选项
export function getPrimarySourceOptions() {
  return [
    { value: 4, label: "保司" },
    { value: 5, label: "监管" },
    { value: 9, label: "企微" },
    { value: 1, label: "京东转接" },
    { value: 0, label: "其他" },
  ];
}
// 投诉来源选项
export function seatTypeOptionsFn() {
  if (apiEnv === 'prod'){
    return [
      { value: '000100001100001', label: "投诉客服组" },
      { value: '000100001100002', label: "投诉挽单进线组" },
      { value: '000100001100003', label: "投诉挽单外呼组" },
    ];
  }
  return [
    { value: '000100001000001', label: "投诉客服组" },
    { value: '000100001000002', label: "投诉挽单进线组" },
    { value: '000100001000003', label: "投诉挽单外呼组" },
  ];
}


// 短险监控所属期 - 表头配置
export function shortInsureTermTheadConfigFn() {
  const monthArr = [
    [
      { name: "m2Num", title: "M2保单数" },
      { name: "m3Num", title: "M3保单数" },
      { name: "m4Num", title: "M4保单数" },
      { name: "m5Num", title: "M5保单数" },
      { name: "m6Num", title: "M6保单数" },
      { name: "m7Num", title: "M7保单数" },
      { name: "m8Num", title: "M8保单数" },
      { name: "m9Num", title: "M9保单数" },
      { name: "m10Num", title: "M10保单数" },
      { name: "m11Num", title: "M11保单数" },
      { name: "m12Num", title: "M12保单数" },
    ],
    [
      { name: "incomeAmountM2", title: "M2扣款成功保费" },
      { name: "incomeAmountM3", title: "M3扣款成功保费" },
      { name: "incomeAmountM4", title: "M4扣款成功保费" },
      { name: "incomeAmountM5", title: "M5扣款成功保费" },
      { name: "incomeAmountM6", title: "M6扣款成功保费" },
      { name: "incomeAmountM7", title: "M7扣款成功保费" },
      { name: "incomeAmountM8", title: "M8扣款成功保费" },
      { name: "incomeAmountM9", title: "M9扣款成功保费" },
      { name: "incomeAmountM10", title: "M10扣款成功保费" },
      { name: "incomeAmountM11", title: "M11扣款成功保费" },
      { name: "incomeAmountM12", title: "M12扣款成功保费" },
    ],
    [
      { name: "realAmountM2", title: "M2实收保费" },
      { name: "realAmountM3", title: "M3实收保费" },
      { name: "realAmountM4", title: "M4实收保费" },
      { name: "realAmountM5", title: "M5实收保费" },
      { name: "realAmountM6", title: "M6实收保费" },
      { name: "realAmountM7", title: "M7实收保费" },
      { name: "realAmountM8", title: "M8实收保费" },
      { name: "realAmountM9", title: "M9实收保费" },
      { name: "realAmountM10", title: "M10实收保费" },
      { name: "realAmountM11", title: "M11实收保费" },
      { name: "realAmountM12", title: "M12实收保费" },
    ],
    [
      { name: "m2RefundRate", title: "M2退款率" },
      { name: "m3RefundRate", title: "M3退款率" },
      { name: "m4RefundRate", title: "M4退款率" },
      { name: "m5RefundRate", title: "M5退款率" },
      { name: "m6RefundRate", title: "M6退款率" },
      { name: "m7RefundRate", title: "M7退款率" },
      { name: "m8RefundRate", title: "M8退款率" },
      { name: "m9RefundRate", title: "M9退款率" },
      { name: "m10RefundRate", title: "M10退款率" },
      { name: "m11RefundRate", title: "M11退款率" },
      { name: "m12RefundRate", title: "M12退款率" },
    ],
    [
      { name: "m2ContinueRate", title: "M2继续率" },
      { name: "m3ContinueRate", title: "M3继续率" },
      { name: "m4ContinueRate", title: "M4继续率" },
      { name: "m5ContinueRate", title: "M5继续率" },
      { name: "m6ContinueRate", title: "M6继续率" },
      { name: "m7ContinueRate", title: "M7继续率" },
      { name: "m8ContinueRate", title: "M8继续率" },
      { name: "m9ContinueRate", title: "M9继续率" },
      { name: "m10ContinueRate", title: "M10继续率" },
      { name: "m11ContinueRate", title: "M11继续率" },
      { name: "m12ContinueRate", title: "M12继续率" },
    ]
  ]


  const result = [
    { name: "date", title: "统计月份" },
    { name: "link", title: "业务链路" },
    { name: "marketChannel", title: "渠道" },
    { name: "ageRange", title: "年龄段" },
    { name: "code", title: "产品code" },
    { name: "productType", title: "保单类型" },
    { name: "insuranceCompany", title: "保司" },
    { name: "cashierDesk", title: "收银台" },
    { name: "payWayDesc", title: "支付方式" },
    { name: "payNum", title: "保单支付数" },
    { name: "totalFee", title: "规模保费" },
    { name: "signNum", title: "保单签约数" },
    { name: "contractRetentionRate", title: "签约留存率" },
    { name: "refundNum", title: "保单退保数" },
  ];

  for (let i=0; i<11; i++){
    monthArr.forEach(item => {
      const temp = item[i];
      if (temp) result.push(temp);
    })
  }

  result.push(...[
    { name: "ableRenewalNum", title: "可续保保单" },
    { name: "hasRenewalNum", title: "保单续保数" },
    { name: "renewalRate", title: "续保继续率" },
  ])

  return result;
}

// 短险监控当日 - 表头配置
export function shortInsureTodayTheadConfigFn() {
  return [
    { name: "date", title: "统计日期" },
    { name: "code", title: "产品code" },
    { name: "policyType", title: "保单类型" },
    { name: "insuranceCompany", title: "保司" },
    { name: "company", title: "经纪公司" },
    { name: "payWay", title: "收银台" },
    { name: "payNum", title: "新单支付数" },
    { name: "policyNum", title: "新单出单数" },
    { name: "policyUpgradeNum", title: "新单升级数" },
    { name: "policyIncome", title: "新单实收保费" },
    { name: "oldPayNum", title: "续保支付数" },
    { name: "oldPolicyNum", title: "续保出单数" },
    { name: "oldPolicyIncome", title: "续保实收保费" },
    { name: "refundNum", title: "退款单数" },
    { name: "refundAmount", title: "退款金额" },
    { name: "periodTow", title: "M2扣费成功数" },
    { name: "periodTowIncome", title: "M2实收保费" },

    { name: "periodThree", title: "M3扣费成功数" },
    { name: "periodThreeIncome", title: "M3实收保费" },

    { name: "periodFour", title: "M4扣费成功数" },
    { name: "periodFourIncome", title: "M4实收保费" },

    { name: "periodFive", title: "M5扣费成功数" },
    { name: "periodFiveIncome", title: "M5实收保费" },

    { name: "periodSix", title: "M6扣费成功数" },
    { name: "periodSixIncome", title: "M6实收保费" },

    { name: "periodSeven", title: "M7扣费成功数" },
    { name: "periodSevenIncome", title: "M7实收保费" },

    { name: "periodEight", title: "M8扣费成功数" },
    { name: "periodEightIncome", title: "M8实收保费" },

    { name: "periodNine", title: "M9扣费成功数" },
    { name: "periodNineIncome", title: "M9实收保费" },

    { name: "periodTen", title: "M10扣费成功数" },
    { name: "periodTenIncome", title: "M10实收保费" },

    { name: "periodEleven", title: "M11扣费成功数" },
    { name: "periodElevenIncome", title: "M11实收保费" },

    { name: "periodTwelve", title: "M12扣费成功数" },
    { name: "periodTwelveIncome", title: "M12实收保费" },
  ];
}


// 投诉来源 - 表头配置
export function complaintSourceTheadConfigFn(){
  return [
    { name: "date", title: "投诉日期" },
    { name: "primarySource", title: "一级投诉来源" },
    { name: "secondarySource", title: "二级投诉来源" },
    { name: "orderCount", title: "工单数量" },
    { name: "closeCount", title: "结案数量" },
    { name: "closeRate", title: "结案率" },
    { name: "autoProcess", title: "自动处理工单数" },
    { name: "autoProcessRate", title: "自动处理占比" },
    { name: "autoClose", title: "自动关闭工单数" },
    { name: "autoCloseRate", title: "自动关闭占比" },
    { name: "deadlineOrderCount", title: "4点前工单数" },
    { name: "deadlineCloseCount", title: "4点前工单结案数量" },
    { name: "deadlineCloseRate", title: "4点前工单结案率" },
  ]
}

// 超时自动处理监控 - 表头配置
export function overtimeAutoHandleTheadConfigFn(){
  return [
    { name: "date", title: "日期" },
    { name: "name", title: "坐席姓名" },
    { name: "allocationCount", title: "分配工单数" },
    { name: "processCount", title: "处理工单数" },
    { name: "processRate", title: "占比" },
    { name: "timeoutCount", title: "超时工单数" },
    { name: "timeoutRate", title: "占比" },
  ]
}
// 400进线报表 - 表头配置
export function lineInTheadConfigFn(){
  return [
    { name: "date", title: "日期" },
    { name: "name", title: "工作时间" },
    { name: "allocationCount", title: "来电类型" },
    { name: "processCount", title: "总进线量" },
    { name: "processRate", title: "去重后进线手机号" },
    { name: "timeoutCount", title: "重复进线次数" },
    { name: "timeoutRate", title: "一周内有结案工单手机号" },
    { name: "a1", title: "一周内有结案工单手机号" },
    { name: "a2", title: "有在保保单手机号" },
    { name: "a3", title: "解约退保手机量" },
    { name: "a4", title: "转挽单坐席量" },
    { name: "a5", title: "转人率" },
    { name: "a6", title: "转人工成功" },
    { name: "a7", title: "漏接率" },
    { name: "a8", title: "需外呼用户数" },
    { name: "a9", title: "外呼用户数" },
    { name: "b1", title: "外呼率" },
    { name: "b2", title: "接通用户数" },
    { name: "b3", title: "外呼接通率" },
  ]
}
// 零犀投诉报表
export function lxComplaintReportTheadConfigFn(){
  return [
    { name: "date", title: "日期", fixed: 'left', align: 'left', width: '140', },
    { name: "typeLabel", title: "话术类型", align: 'left' },
    { name: "magic", title: "魔方出单数" },
    { name: "magicComplaint", title: "魔方投诉数" },
    { name: "magicComplaintRate", title: "魔方投诉比例" },
    { name: "average", title: "均分出单数" },
    { name: "averageComplaint", title: "均分投诉数" },
    { name: "averageComplaintRate", title: "均分投诉比例" },
  ]
}
// 客服通话汇总表
export function callRecordReportTheadConfigFn(){
  return [
    { name: "date", title: "日期", fixed: 'left', align: 'left', width: '140', },
    { name: "name", title: "坐席名称", fixed: 'left', align: 'left', width: '100', },
    { name: "callInCount", title: "呼入数量" },
    { name: "callInTransferCount", title: "呼入人工接通数量" },
    { name: "callInNoTransferCount", title: "漏接数量" },
    { name: "callInNoTransferRate", title: "漏接率" },
    { name: "callInManualTimingStr", title: "呼入双方接听时长" },
    { name: "callOutCount", title: "呼出数量" },
    { name: "callOutConnectCount", title: "呼出接通数量" },
    { name: "callOutConnectRate", title: "接通率" },
    { name: "callOutManualTimingStr", title: "呼出双方接听时长" },
    { name: "allConnectCount", title: "总通次" },
    { name: "allManualTimingStr", title: "总通时" },
    { name: "processOrder", title: "处理工单数" },
    { name: "closeOrder", title: "结案工单数" },
    { name: "replyCustomer", title: "公众号回复客户数" },
    { name: "replyCount", title: "公众号回复次数" },
  ]
}
// 当日口径结案报表
export function settleReportTheadConfigFn(){
  return [
    { name: "date", title: "投诉日期", fixed: 'left',width: '110', align: 'left'},
    { name: "primarySourceLabel", title: "一级来源", fixed: 'left', align: 'left', width: '100', },
    { name: "secondarySourceLabel", title: "二级来源",fixed: 'left', align: 'left', width: '130', },
    { name: "orderCount", title: "工单数量" },
    { name: "processCount", title: "已处理数量" },
    { name: "processRate", title: "处理率" },
    { name: "closeCount", title: "结案数量" },
    { name: "closeRate", title: "结案率" },
    { name: "deadlineOrderCount", title: "五点前工单数" },
    { name: "deadlineCloseCount", title: "五点前结案数" },
    { name: "deadlineCloseRate", title: "五点前结案率" },
    { name: "autoProcess", title: "自动结案数量" },
    { name: "autoProcessRate", title: "自动结案率" }
  ]
}
// 投诉报表 - 表头配置
export function complaintReportTheadConfigFn(){
  return [
    {
      title: "日期", name: "date", fixed: 'left', width: '140',
      headChildren: [
        {name: "complaintDate", title: "投诉日期", align: 'left'},
      ]
    },
    {
      title: "来源",name: "source", fixed: 'left', width: '230',
      headChildren: [
        {name: "primarySourceLabel", title: "一级来源", align: 'left'},
        {name: "secondarySourceLabel", title: "二级来源", align: 'left'},
      ]
    },
    {
      title: "用户",name: "user",
      headChildren: [
        {name: "totalUsers", title: "总用户量" },
        {name: "uniqueUsers", title: "去重用户量" },
        {name: "repeatCallRate", title: "重复率" },
      ]
    },
    {
      title: "来电分析",name: "phone",
      headChildren: [
        {name: "phoneVerifiedUsers", title: "手机号验证用户" },
        {name: "phoneVerifiedUsersRatio", title: "比例" },
        {name: "phoneVerificationPassedUsers", title: "手机号验证通过用户" },
        {name: "phoneVerificationPassedRatio", title: "比例" },
        {name: "phoneNoPolicy", title: "手机号无保单用户" },
        {name: "phoneNoPolicyRatio", title: "比例" },
        {name: "phoneMatchFail", title: "手机号匹配失败用户" },
        {name: "phoneMatchFailRatio", title: "比例" },
        {name: "idVerifiedUsers", title: "验证身份证用户" },
        {name: "idVerifiedUsersRatio", title: "比例" },
        {name: "idVerificationPassedUsers", title: "验证身份证通过用户" },
        {name: "idVerificationPassedRatio", title: "比例" },
        {name: "idNoPolicy", title: "身份证号无保单用户" },
        {name: "idNoPolicyRatio", title: "比例" },
        {name: "idMatchFail", title: "身份证号匹配失败用户" },
        {name: "idMatchFailRatio", title: "比例" },
        {name: "transferredUsers", title: "转人数量" },
        {name: "transferRate", title: "转人率" },
        {name: "successfulTransfers", title: "转人成功数量" },
        {name: "successfulTransferRate", title: "转人成功率" },
      ]
    },
    {
      title: "结案分析",name: "work",
      headChildren: [
        {name: "workOrders", title: "工单数量" },
        {name: "workOrderSubmissionRate", title: "工单提交率" },
        {name: "navigationGeneratedWorkOrders", title: "导航生成工单" },
        {name: "navigationWorkOrderRatio", title: "工单占比" },
        {name: "closedOrders", title: "结案数量" },
        {name: "closingRate", title: "结案率" },
        {name: "autoClosedOrders", title: "自动结案数量" },
        {name: "autoClosingRate", title: "自动结案率" },
        // {name: "autoClosingRatio", title: "比例" },
      ]
    },
    {
      title: "重复投诉分析(投诉后一周)",name: "consultation",
      headChildren: [
        {name: "consultationUpgradedComplaints", title: "升级投诉用户" },
        {name: "consultationUpgradedComplaintsRatio", title: "比例" },
        {name: "repeatSubmissions25", title: "2-5次以上重复提交用户数" },
        {name: "repeatSubmissions25Ratio", title: "重复率" },
        {name: "repeatSubmissions5Plus", title: "5次以上重复提交用户数" },
        {name: "repeatSubmissions5PlusRatio", title: "重复率" },
      ]
    },
    {
      title: "用户标签分析(投诉前一周)",name: "average",
      headChildren: [
        {name: "averageRenewalUsers", title: "均分续期用户" },
        {name: "averageRenewalUsersRatio", title: "比例" },
        {name: "magicUpgradeM2RenewalUsers", title: "魔方升级M2续期用户" },
        {name: "magicUpgradeM2RenewalUsersRatio", title: "比例" },
        {name: "magicUpgradeM3RenewalUsers", title: "魔方升级M3续期用户" },
        {name: "magicUpgradeM3RenewalUsersRatio", title: "比例" },
        {name: "lowPriceMagicRenewalUsers", title: "低价魔方续期用户" },
        {name: "lowPriceMagicRenewalUsersRatio", title: "比例" },
        {name: "averageNewOrdersUsers", title: "均分新单用户" },
        {name: "averageNewOrdersUsersRatio", title: "比例" },
        {name: "magicNewOrdersUsers", title: "魔方新单用户" },
        {name: "magicNewOrdersUsersRatio", title: "比例" },
        {name: "magicNewOrdersUpgradeUsers", title: "魔方新单升级用户" },
        {name: "magicNewOrdersUsersUpgradeRatio", title: "比例" },
        {name: "otherUsers", title: "其他用户" },
        {name: "otherUsersRatio", title: "比例" },
      ]
    },
    {
      title: "留存分析(仅包含结案工单)",name: "liuchun",
      headChildren: [
        {name: "complaintUsers", title: "投诉用户数" },
        {name: "surrenderCount", title: "退保数" },
        {name: "surrenderRatio", title: "比例" },
        {name: "actualRefundedPremium", title: "实退保费" },
        {name: "actualRefundedScalePremium", title: "实退规模保费" },
        {name: "terminationCount", title: "解约数" },
        {name: "terminationRatio", title: "比例" },
        {name: "retentionCount", title: "留存数" },
        {name: "retentionRatio", title: "比例" },
      ]
    },
  ]
}

// 每日工作人数 - 表头配置
export function dailyWorkPeopleTheadConfigFn() {
  return [
    { name: "date", title: "日期" },
    { name: "num", title: "人数" },
    { name: "options", title: "操作" },
  ];
}

// 来电统计 - 表头配置
export function callInTheadConfigFn(){
  return [
    { name: "day", title: "日期" },
    { name: "type", title: "类型" },
    { name: "count", title: "来电数量" },
    { name: "soleCount", title: "去重来电数量" },
    { name: "soleRate", title: "重复进线率" },
    { name: "transferCount", title: "转人数量" },
    { name: "transferRate", title: "转人率" },
    { name: "transferSuccessCount", title: "转人成功数量" },
    { name: "transferSuccessRate", title: "转人成功率" },
    { name: "orderCount", title: "工单数量" },
    { name: "orderRate", title: "工单提交率" },
    { name: "orderSuccessCount", title: "结案数量" },
    { name: "orderSuccessRate", title: "结案率" },
    { name: "checkPhoneErrorFirstCount", title: "一次手机号验证失败" },
    { name: "checkPhoneErrorFirstRate", title: "比例" },
    { name: "checkPhoneErrorTwoCount", title: "二次手机号验证失败" },
    { name: "checkPhoneErrorTwoRate", title: "比例" },
    { name: "checkIdNoErrorFirstCount", title: "一次身份证号验证失败" },
    { name: "checkIdNoErrorFirstRate", title: "比例" },
    { name: "checkIdNoErrorTwoCount", title: "二次身份证号验证失败" },
    { name: "checkIdNoErrorTwoRate", title: "比例" },
  ]
}

// 工单人群 - 表头配置
export function complaintPeopleTheadConfigFn(){
  return [
    { name: "date", title: "日期" },
    { name: "primarySource", title: "总工单用户量" },
    { name: "secondarySource", title: "总工单用户量" },
    { name: "orderCount", title: "重复率" },
    { name: "closeCount", title: "2-5次以上重复提交用户数" },
    { name: "closeRate", title: "重复率" },
    { name: "autoProcess", title: "5次以上重复提交用户数" },
    { name: "autoProcessRate", title: "重复率" },
    { name: "autoClose", title: "近一周均分单续期扣费成功用户" },
    { name: "autoCloseRate", title: "比例" },
    { name: "deadlineOrderCount", title: "近一周魔方升级单M2扣费成功用户" },
    { name: "deadlineCloseCount", title: "比例" },
    { name: "deadlineCloseRate", title: "近一周魔方升级单续期扣费成功用户" },
    { name: "deadlineCloseRate2", title: "比例" },
    { name: "deadlineCloseRate3", title: "近一周魔方未升级单续期扣费成功用户" },
    { name: "deadlineCloseRate4", title: "比例" },
    { name: "deadlineCloseRate5", title: "近一周均分新单用户" },
    { name: "deadlineCloseRate6", title: "比例" },
    { name: "deadlineCloseRate7", title: "近一周魔方已升级新单用户" },
    { name: "deadlineCloseRate8", title: "比例" },
    { name: "deadlineCloseRate9", title: "近一周魔方未升级新单用户" },
    { name: "deadlineCloseRate10", title: "比例" },
    { name: "deadlineCloseRate11", title: "近一周营销且无在保保单用户" },
    { name: "deadlineCloseRate12", title: "比例" },
  ]
}

// 工单处理结果 - 表头配置
export function complaintResultTheadConfigFn(){
  return [
    { name: "date", title: "日期" },
    { name: "userCount", title: "用户量" },
    { name: "refundCount", title: "退保保单数" },
    { name: "autoRefundCount", title: "自动退保保单数" },
    { name: "refundPremium", title: "退保保费" },
    { name: "refundAmount", title: "退保规模保费" },
    { name: "unsignCount", title: "解约保单数" },
    { name: "autoUnsignCount", title: "自动解约保单数" },
  ]
}

// 投诉处理能力 - 表头配置
export function complaintDisposeStatsTheadConfigFn() {
  return [
    { name: "date", title: "日期" },
    { name: "type", title: "作业时间" },
    { name: "link", title: "链路" },
    { name: "primarySource", title: "投诉来源" },
    { name: "jobOrderCount", title: "工单数量" },
    { name: "repeatComplaintRate", title: "用户重复投诉率" },
    { name: "importantCloseRate", title: "重要工单结案率" },
    { name: "closeRate", title: "结案率" },
    { name: "restoreRate", title: "挽单率" },
  ];
}

// 脱退报表 - 表头配置
export function detainmentTtTheadConfigFn() {
  return [
    { name: "date", title: "日期", align: 'left', fixed: 'left', minWidth: 140},
    { name: "groupName", title: "职场", minWidth: 120 },
    { name: "agentName", title: "坐席", minWidth: 80 },
    { name: "policySuccess", title: "月缴均分出单数" },
    { name: "jobOrderNum", title: "月缴提交退保/解约数" },
    { name: "jobOrderRate", title: "月缴提交工单率" },
    { name: "yearPolicySuccess", title: "年缴均分出单数" },
    { name: "yearJobOrderNum", title: "年缴提交退保/解约数" },
    { name: "yearJobOrderRate", title: "年缴提交工单率" },
    { name: "retentionNum", title: "挽单成功数" },
    { name: "retentionRate", title: "挽单率" },
  ];
}
// 回拨挽单报表 - 表头配置
export function detainmentCallbackTheadConfigFn() {
  return [
    { name: "date", title: "日期", align: 'left', fixed: 'left', minWidth: 140 },
    { name: "agentName", title: "坐席", minWidth: 80 },
    { name: "callOutDuration", title: "总外呼时长" },
    { name: "averageOutDuration", title: "平均外呼时长" },
    { name: "outCount", title: "拨打量" },
    { name: "outConnectCount", title: "接通量" },
    { name: "outConnectRate", title: "拨打接通率" },
    { name: "callJobOrderNum", title: "拨打工单数" },
    { name: "callSuccessJobOrderNum", title: "接通工单数" },
    { name: "callSuccessRate", title: "接通率" },
    { name: "retentionNum", title: "标记挽单数" },
    { name: "retentionSuccessNum", title: "挽单成功数" },
    { name: "retentionDifferenceRate", title: "二次退保率" },
    { name: "callRate", title: "工单拨打率" },
    { name: "retentionCallSuccessRate", title: "接通工单挽单率" },
    { name: "unCloseRate", title: "24小时未结案率" },
    { name: "lbPremium", title: "利宝规模保费" },
    { name: "tpPremium", title: "太平规模保费" },
    { name: "tkPremium", title: "泰康规模保费" },
    { name: "zhPremium", title: "众惠规模保费" },
    { name: "jobOrderId", title: "工单ID", minWidth: 160 },
  ];
}
// 进线挽单报表 - 表头配置
export function detainmentIncomeTheadConfigFn() {
  return [
    { name: "date", title: "日期", align: 'left', fixed: 'left', minWidth: 140 },
    { name: "agentName", title: "坐席", minWidth: 80 },
    { name: "channelTypeCn", title: "渠道", minWidth: 100 },
    { name: "transferNum", title: "转人申请量" },
    { name: "outConnectCount", title: "接通量" },
    { name: "outConnectCountRaw", title: "接通量(未去重)" },
    { name: "missedRate", title: "漏接率" },
    { name: "callOutDuration", title: "总接通时长" },
    { name: "averageOutDuration", title: "平均接通时长" },
      { name: "retentionNum", title: "标记挽单数" },
    { name: "retentionSuccessNum", title: "挽单成功数" },
    { name: "jobOrderPolicyNum", title: "工单保单数量" },
    { name: "retentionRate2", title: "挽单成功率" },
      { name: "retentionDifferenceRate", title: "二次退保率" },
    { name: "closeOrderNum", title: "人工结案量" },
    { name: "callJobOrderNum", title: "工单数" },
    { name: "closeOrderRate", title: "人工结案率" },
    { name: "unCloseRate", title: "24小时未结案率" },
    { name: "tkPremium", title: "泰康规模保费" },
    { name: "tpPremium", title: "太平规模保费" },
    { name: "zhPremium", title: "众惠规模保费" },
    { name: "lbPremium", title: "利宝规模保费" },
    { name: "jobOrderId", title: "工单ID", minWidth: 160 },
  ];
}

// 重疾均分挽单报表 - 表头配置
export function detainmentZjJfTheadConfigFn() {
  return [
    ...detainmentIncomeTheadConfigFn(),
  ];
}


export function getDimensionalConfig(){
  const result = [
    {
      title: '维度',
      options: [
        {value: 'type', label: '作业时间'},
        {value: 'link', label: '链路'},
        {value: 'primarySource', label: '投诉来源'},
      ],
    },
    {
      title: '指标',
      options: [
        {value: 'jobOrderCount', label: '工单数量'},
        {value: 'repeatComplaintRate', label: '用户重复投诉率'},
        {value: 'importantCloseRate', label: '重要工单结案率'},
        {value: 'closeRate', label: '结案率'},
        {value: 'restoreRate', label: '挽单率'},
      ],
    },
  ]
  return result.map(item => ({
    ...item,
    selectedProps: item.options.map(ii => ii.value),
  }))
}


// 投诉指标报表
export function complaintTargetTheadConfigFn(){
  return [
    { name: "date", title: "日期", fixed: 'left', align: 'center' },
    { name: "orderCloseRate", title: "重要工单完结率"},
    { name: "transferSuccessRate", title: "京东转人成功率" },
    { name: "jdComplaintRate", title: "累计收银台投诉率" },
    { name: "repeatOrderRate", title: "重复投诉率" },
    { name: "retentionRate", title: "均分挽单率" },
  ]
}
// 投诉报表 - 表头配置
export function complaintOriginTheadConfigFn(){
  return [
    {
      title: "日期", name: "date", fixed: 'left', width: '140', align: 'left'
    },
    {
      title: "来源", name: "source", width: '230',
      headChildren: [
        {name: "primarySourceLabel", title: "一级来源", align: 'left', },
        {name: "secondarySourceLabel", title: "二级来源", align: 'left', },
      ]
    },
    // {name: "primarySourceLabel", title: "一级来源", align: 'left', },
    // {name: "secondarySourceLabel", title: "二级来源", align: 'left', },
    {title: "数量",name: "count"},
    {title: "占比",name: "rate"},
  ]
}
// 客服评价报表
export function seatEvaluateTheadConfigFn(){
  return [
    { name: "date", title: "日期" },
    { name: "orgName", title: "职场"},
    { name: "agentName", title: "坐席" },
    { name: "evaluateRate", title: "评价率" },
    { name: "callCount", title: "总通话数" },
    { name: "evaluateCount", title: "总评价数" },
    { name: "evaluateScore", title: "总评价分" },
    { name: "dissatisfiedRate", title: "不满意率" },
    { name: "dissatisfiedPhones", title: "不满意用户手机号" },
    // { name: "connectRate", title: "接通率" },
    // { name: "avgDuration", title: "平均通话时长 s" },
  ]
}
// 投诉报表 - 二次监管工单监控 表头
export function secondJggdTheadConfigFn(){
  return [
    { name: "date", title: "日期", fixed: 'left', align: 'center' },
    { name: "seatType", title: "人员类型"},
    { name: "seatName", title: "姓名"},
    { name: "closeCount", title: "人工结案工单量" },
    { name: "regulatoryCount", title: "其中产生二次监管工单量" },
    { name: "jobOrderIdList", title: "二次监管工单ID(手机号)" },
    { name: "regulatoryRate", title: "二次监管工单占比" },
  ]
}
// 投诉报表 - 客服通话数据表 - 表头配置
export function krCallTheadConfigFn(){
  return [
    { name: "callDate", title: "日期" },
    { name: "name", title: "客服姓名" },
    { name: "connectCount", title: "总通话量" },
    { name: "callIn", title: "进线接通量" },
    { name: "missCallInStr", title: "漏接率" },
    { name: "callInDurationStr", title: "总进线接通时长" },
    { name: "callInDurationAvr", title: "平均进线接通时长" },
    { name: "callOut", title: "外呼量" },
    { name: "callOutConnect", title: "外呼接通量" },
    { name: "callOutSuccessRate", title: "外呼接通率" },
    { name: "callOutDurationStr", title: "总外呼接通时长" },
    { name: "callOutDurationAvr", title: "平均外呼接通时长" },
    { name: "busyTime", title: "置忙时长" },
  ]
}
// 投诉报表 - 企微消息数据监控 - 表头配置
export function qwReplyTheadConfigFn(){
  return [
      {
          title: "日期", name: "date", fixed: 'left', width: '158',
          headChildren: [
              { name: "statDate", title: "日期" },
              { name: "userName", title: "坐席姓名" },
          ]
      },
      {
          title: "总量",name: "total",
          headChildren: [
              { name: "consultUserCountAll", title: "咨询客户量" },
              { name: "userMsgTotalAll", title: "客户消息发送量" },
              { name: "agentReplyUserCountAll", title: "坐席回复客户量" },
              { name: "agentMsgTotalAll", title: "坐席回复客户消息量" },
              { name: "agentReplyRateAll", title: "坐席回复率" },
              { name: "totalFirstReplyDurationAll", title: "坐席首次总回复时间" },
              { name: "avgFirstReplyDurationAll", title: "坐席首次平均回复时间" },
          ]
      },
      {
          title: "当日",name: "today",
          headChildren: [
              { name: "consultUserCount", title: "咨询客户量" },
              { name: "userMsgTotal", title: "客户消息发送量" },
              { name: "agentReplyUserCount", title: "坐席回复客户量" },
              { name: "agentMsgTotal", title: "坐席回复客户消息量" },
              { name: "agentReplyRate", title: "坐席回复率" },
              { name: "totalFirstReplyDuration", title: "坐席首次总回复时间" },
              { name: "avgFirstReplyDuration", title: "坐席首次平均回复时间" },
          ]
      },
      {
          title: "隔夜",name: "overnight",
          headChildren: [
              { name: "consultUserCountOvernight", title: "咨询客户量" },
              { name: "userMsgTotalOvernight", title: "客户消息发送量" },
              { name: "agentReplyUserCountOvernight", title: "坐席回复客户量" },
              { name: "agentMsgTotalOvernight", title: "坐席回复客户消息量" },
              { name: "agentReplyRateOvernight", title: "坐席回复率" },
              { name: "totalFirstReplyDurationOvernight", title: "坐席首次总回复时间" },
              { name: "avgFirstReplyDurationOvernight", title: "坐席首次平均回复时间" },
          ]
      },
  ]
}




// a段合并扣费 - 筛选选项集合
export function getAMergeDeductFilterOptions(params){
  const {type} = params;
  const result = {
    aInsureCompany: [
      {value: 1, label: '泰康'},
      {value: 2, label: '利宝'},
    ],
    groupType: [
      {value: 1, label: '实验组'},
      {value: 2, label: '对照组'},
    ],
    paymentScore: [
      {value: 1, label: '0分'},
      {value: 2, label: '1分'},
      {value: 3, label: '2、3分'},
      {value: 4, label: '4分及以上'},
    ],
    userType: [
      {value: 1, label: '百万'},
      {value: 2, label: '百万+重疾'},
      {value: 3, label: '百万+重疾+意外'},
    ],
    ageGroup: [
      {value: 2, label: '31-35'},
      {value: 3, label: '36-40'},
      {value: 4, label: '41-45'},
      {value: 5, label: '46-50'},
      {value: 6, label: '51-55'},
      {value: 7, label: '56-60'},
    ],
    pendingOrderType: [
      {value: 1, label: '防癌'},
      {value: 2, label: '防癌+重疾'},
    ],
  }

  if (type === 2){
    result.channelType = [
      {value: 1, label: 'BPO'},
      {value: 2, label: '投放'},
      {value: 3, label: '点拨'},
    ]
    result.userType = [
      {value: 21, label: '泰康'},
      {value: 22, label: '利宝'},
    ]
    result.ageGroup = [
      {value: 1, label: '30及以下'},
      {value: 2, label: '31-35'},
      {value: 3, label: '36-40'},
      {value: 4, label: '41-45'},
      {value: 5, label: '46-50'},
      {value: 6, label: '51-55'},
      {value: 7, label: '56-60'},
      {value: 8, label: '60及以上'},
    ]
  }

  return delayMock(result, 100);
}
// a段合并扣费 - 表头配置
export function aMergeDeductTheadConfigFn() {
  return [
    { name: "date", title: "日期", align: 'left', fixed: 'left', tip: '小保单支付日期'},
    { name: "phaseA", title: "a段保司" },
    { name: "ageRange", title: "年龄段" },
    { name: "channel", title: "支付分" },
    { name: "groupType", title: "组别" },
    { name: "userType", title: "用户类型" },
    { name: "orderType", title: "挂单类型" },
    { name: "userCount", title: "用户数" },
    { name: "originalPremium", title: "原规模保费" },
    { name: "cancerPremium", title: "挂单防癌规模保费" },
    { name: "originalActualPay", title: "原保单实收" },
    { name: "incrementActualPay", title: "增量保费实收" },
    { name: "totalActualPay", title: "总保费实收" },
    { name: "originalM2RenewalRateStr", title: "原单m2继续率", tip: 'm2实收/m2应收\nm2实收：原单的m2实收金额\nm2应收：原单的m2应收金额' },
    { name: "operatedM2RenewalRateStr", title: "运营后m2继续率", tip: '运营后实收/原单m2应收\n运营后实收：原单的m2实收金额+挂单防癌的m1实收金额\nm2应收：原单的m2应收金额' },
    { name: "complaintRateStr", title: "投诉率", tip: '投诉的用户数/m2扣款成功的用户数\n投诉的用户数：原单m2或捆绑单m1扣款成功后投诉的用户数\nm2扣款成功用户数：原单m2或捆绑单m1扣款成功的用户数' },
    { name: "cancelRefundRateStr", title: "解约退保率", tip: '解约或退保的用户数/m2扣款成功的用户数\n解约退保的用户数：原单m2或捆绑单m1扣款成功后解约或退保的用户数\nm2扣款成功用户数：原单m2或捆绑单m1扣款成功的用户数' },
  ];
}

// 降级扣费 - 表头配置
export function aRelegateDeductTheadConfigFn() {
  return [
    { name: "date", title: "日期", align: 'left', fixed: 'left', tip: '小保单支付日期'},
    { name: "ageRange", title: "年龄段" },
    { name: "channel", title: "渠道" },
    { name: "groupType", title: "组别" },
    { name: "userType", title: "用户类型" },
    { name: "userCount", title: "用户数" },
    { name: "originalPremium", title: "原规模保费" },
    { name: "cancerPremium", title: "降级规模保费" },
    { name: "originalActualPay", title: "原保单实收" },
    { name: "incrementActualPay", title: "降级保费实收" },
    { name: "totalActualPay", title: "总保费实收" },
    { name: "originalM2RenewalRateStr", title: "原单m2继续率"},
    { name: "operatedM2RenewalRateStr", title: "运营后m2继续率"},
    { name: "complaintRateStr", title: "投诉率"},
    { name: "cancelRefundRateStr", title: "解约退保率"},
  ];
}
